import { BagStatusTypeEnum } from "./BagStatusTypeEnum";
import { BundlerStatusTypeEnum } from "./BundlerStatusTypeEnum";
import { CleaningStatusTypeEnum } from "./CleaningStatusTypeEnum";
import { CoverStatusTypeEnum } from "./CoverStatusTypeEnum";
import { DoorStatusTypeEnum } from "./DoorStatusTypeEnum";
import { GlobalStatusEnum } from "./GlobalStatusEnum";
import { MaintenanceStatusEnum } from "./MaintenanceStatusEnum";
import { StatusEnum } from "./StatusEnum";

export class MachineStatus {
    /** Nome dell'installazione a cui appartiene la macchina di cui si sta definendo lo stato*/
    machineInstallationName: string;

    /** Serial number della macchina a cui ci si sta riferendo */
    machineSerialNumber: string;

    /** Machine globalStatus
     * Ok, Ko, Unknown */
    globalStatus: GlobalStatusEnum;

    /** Machine status
     * Unknown, Busy, Online, Offline, OutOfService, Full */
    status: StatusEnum;

    /** Stato di pulizia
     * Unknown, NotNecessary, Necessary */
    cleaningStatus: CleaningStatusTypeEnum;

    /** Stato della porta della cassaforte
     * Unknown, Open, Closed */
    doorStatus: DoorStatusTypeEnum;

    /** Stato della cover
     * Unknown, Open, Closed */
    coverStatus: CoverStatusTypeEnum;

    /** Stato della sacca
     * Unsupported, Unknown, Empty, Full, Ok, Closed, Blocked, WrongPosition, NotPresent, Miscount, MiscountOverridden, FullSensorCoveredAndBagEmpty*/
    bagStatus: BagStatusTypeEnum;

    /** Bundler stutus
     * Unsupported, Unknown, Ok, Blocked, PaperNearEnd, PaperFinished */
    bundlerStatus: BundlerStatusTypeEnum;

    /** Magazzini bloccati, lista dei magazzini bloccati, partendo a contare da 1,  */
    blockedStocks: number[];

    /** Error field */
    extension: string;

    /** Ultimo aggiornamento dello stato di questa macchina */
    lastUpdate: Date;

    /** This prop indicates if this machine has at least one mechanical component with a processed pieces counter over the CIMA suggested threshold */
    maintenanceRequired: boolean;

    /** This prop indicates the closest date for the next forecasted maintenance */
    nextMaintenance: Date;

    /** Last update of maintenance forecasts */
    lastMaintenanceForecastsUpdate: Date;

    maintenanceStatus: MaintenanceStatusEnum;

    constructor() {
        this.machineInstallationName = null;
        this.machineSerialNumber = null;
        this.globalStatus = GlobalStatusEnum.Unknown;
        this.status = StatusEnum.Unknown;
        this.cleaningStatus = CleaningStatusTypeEnum.Unknown;
        this.doorStatus = DoorStatusTypeEnum.Unknown;
        this.coverStatus = CoverStatusTypeEnum.Unknown;
        this.bagStatus = BagStatusTypeEnum.Unknown;
        this.bundlerStatus = BundlerStatusTypeEnum.Unknown;
        this.blockedStocks = [];
        this.extension = null;
        this.lastUpdate = null;
        this.maintenanceRequired = false;
        this.nextMaintenance = null;
        this.lastMaintenanceForecastsUpdate = null;
        this.maintenanceStatus = MaintenanceStatusEnum.Regular;
    }

    public parse(obj: any) {
        if (obj.MachineInstallationName) this.machineInstallationName = obj.MachineInstallationName;
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (Object.values(GlobalStatusEnum).includes(obj.GlobalStatus)) this.globalStatus = obj.GlobalStatus;
        if (Object.values(StatusEnum).includes(obj.Status)) this.status = obj.Status;
        if (Object.values(CleaningStatusTypeEnum).includes(obj.CleaningStatus)) this.cleaningStatus = obj.CleaningStatus;
        if (Object.values(DoorStatusTypeEnum).includes(obj.DoorStatus)) this.doorStatus = obj.DoorStatus;
        if (Object.values(CoverStatusTypeEnum).includes(obj.CoverStatus)) this.coverStatus = obj.CoverStatus;
        if (Object.values(BagStatusTypeEnum).includes(obj.BagStatus)) this.bagStatus = obj.BagStatus;
        if (Object.values(BundlerStatusTypeEnum).includes(obj.BundlerStatus)) this.bundlerStatus = obj.BundlerStatus;
        if (obj.BlockedStocks && obj.BlockedStocks.length > 0)
            obj.BlockedStocks.forEach((e: number) => {
                this.blockedStocks.push(e);
            });
        if (obj.Extension) this.extension = obj.Extension;
        if (obj.LastUpdate) this.lastUpdate = obj.LastUpdate;
        if (obj.MaintenanceRequired != null) this.maintenanceRequired = obj.MaintenanceRequired;
        if (obj.NextMaintenance) this.nextMaintenance = new Date(obj.NextMaintenance);
        if (obj.LastMaintenanceForecastsUpdate) this.lastMaintenanceForecastsUpdate = new Date(obj.LastMaintenanceForecastsUpdate);
        if (obj.MaintenanceStatus != null && Object.values(MaintenanceStatusEnum).includes(obj.MaintenanceStatus)) this.maintenanceStatus = obj.MaintenanceStatus;
    }
}
